/**
 * Accounts created when someone pays for a Goal-Setting Meeting start at the
 * "meeting" stage: a welcome screen with nothing to connect. Signing a plan
 * agreement sets `plan_client`, which opens the full portal. Accounts created
 * any other way (existing clients, self sign-up) are never held back.
 */
export function isMeetingStageUser(user) {
  const meta = (user && user.user_metadata) || {};
  return meta.source === 'goal_setting_meeting' && meta.plan_client !== true;
}

/** True when the portal was opened from the "set your password" link in the booking email. */
export function isAccountSetupLink(search = typeof window !== 'undefined' ? window.location.search : '') {
  return new URLSearchParams(search || '').get('setup') === '1';
}
